// locale for Spritelab

import safeLoadLocale from '@cdo/apps/util/safeLoadLocale';

export default safeLoadLocale('spritelab_locale');
